// ------------------------------------
// Constants/Types
// ------------------------------------
const UPDATE_COMPARISON_TIME_PERIOD = 'src/comparison-time-period/UPDATE_COMPARISON_TIME_PERIOD';

export default {
  UPDATE_COMPARISON_TIME_PERIOD
};
